<strong style="font-size: small;">{{layerDescriptor.title | translateHs : {module: 'LAYERS'} }}</strong>